import { BarChart3, LineChart, Mail, Users } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CampaignMetrics } from "@/services/communication/campaignAnalyticsService";

interface CampaignMetricsCardProps {
  metrics: CampaignMetrics;
}

export function CampaignMetricsCard({ metrics }: CampaignMetricsCardProps) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">{metrics.name}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-1">
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Recipients</span>
              <span className="font-medium">{metrics.totalRecipients}</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Delivered</span>
              <span className="font-medium">{metrics.deliveryRate}%</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Opens</span>
              <span className="font-medium">{metrics.openRate}%</span>
            </div>
          </div>
          <div className="space-y-1">
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Clicks</span>
              <span className="font-medium">{metrics.clickRate}%</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Responses</span>
              <span className="font-medium">{metrics.responseRate}%</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Bounces</span>
              <span className="font-medium">{metrics.bounceRate}%</span>
            </div>
          </div>
          
          {/* Progress bars for key metrics */}
          <div className="col-span-2 mt-2 space-y-3">
            <div className="space-y-1">
              <div className="flex items-center justify-between text-xs">
                <span className="font-medium">Open Rate</span>
                <span>{metrics.openRate}%</span>
              </div>
              <div className="h-1.5 w-full rounded-full bg-muted">
                <div 
                  className="h-1.5 rounded-full bg-primary" 
                  style={{ width: `${metrics.openRate}%` }} 
                />
              </div>
            </div>
            
            <div className="space-y-1">
              <div className="flex items-center justify-between text-xs">
                <span className="font-medium">Click Rate</span>
                <span>{metrics.clickRate}%</span>
              </div>
              <div className="h-1.5 w-full rounded-full bg-muted">
                <div 
                  className="h-1.5 rounded-full bg-primary" 
                  style={{ width: `${metrics.clickRate}%` }} 
                />
              </div>
            </div>
            
            <div className="space-y-1">
              <div className="flex items-center justify-between text-xs">
                <span className="font-medium">Response Rate</span>
                <span>{metrics.responseRate}%</span>
              </div>
              <div className="h-1.5 w-full rounded-full bg-muted">
                <div 
                  className="h-1.5 rounded-full bg-primary" 
                  style={{ width: `${metrics.responseRate}%` }} 
                />
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}